import standardAPI from '@/api/standard_items';

const responseUrl = '/levels';

const state = {
  levels: [],
  levels_MetaData: {},
  levels_status: '',
  levels_page: 1,
  levels_perPage: 10,
};

const getters = {
  get_levels: (state) => {
    return state.levels;
  },
  get_levels_status: (state) => {
    return state.levels_status;
  },
};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_levels ({ commit }, getOptions) {
    commit('DATA_LEVELS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('DATA_LEVELS_SUCCESS', response);
            commit('DATA_LEVELS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('DATA_LEVELS_READY');
            reject(response);
          } else {
            commit('DATA_LEVELS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_level ({ commit, dispatch }, itemData) {
    commit('DATA_LEVELS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('DATA_LEVELS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_LEVELS_READY');
          reject(response);
        }
      });
    });
  },
  edit_level ({ commit, dispatch }, itemData) {
    commit('DATA_LEVELS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('DATA_LEVELS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_LEVELS_READY');
          reject(response);
        }
      });
    });
  },
  remove_levels ({ commit, dispatch }, itemData) {
    commit('DATA_LEVELS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('DATA_LEVELS_REQUEST');
          resolve(response);
        } else {
          commit('DATA_LEVELS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_level ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve();
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.levels_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.levels_perPage = max;
  },
  DATA_LEVELS_READY: (state) => {
    state.levels_status = 'ready';
  },
  DATA_LEVELS_REQUEST: (state) => {
    state.levels_status = 'loading';
  },
  DATA_LEVELS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.levels_MetaData.meta = response.meta;
      state.levels_MetaData.links = response.links;
    }
    state.levels = response.data;
    state.levels_status = 'success';
  },
  DATA_LEVELS_ERROR: (state) => {
    state.levels_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
